import { CART_CLONE_BASE_STYLES } from './cart-fly-item.constants';

export const adjustForSafeArea = (coordinate: number, inset: number): number => {
    return coordinate - inset;
};

export const getClosest = (elem: Element | null, selector: string): Element | null => {
    let current: Element | null = elem;

    while (current && current !== document.documentElement) {
        if (current.matches(selector)) {
            return current;
        }

        current = current.parentElement;
    }

    return null;
};

export const supportsElementAnimation = (element: Element | null): element is HTMLElement => {
    return !!element && typeof (element as HTMLElement).animate === 'function';
};

export const miniCartShake = (miniCart: HTMLElement): void => {
    if (!supportsElementAnimation(miniCart)) {
        return;
    }

    miniCart.animate(
        [
            { transform: 'translate3d(0,0,0) scale(1)', offset: 0 },
            { transform: 'translate3d(0,0,0) scale(1.05)', offset: 0.2 },
            { transform: 'translate3d(-1.5px,0,0) scale(1.015) rotate(-2deg)', offset: 0.42 },
            { transform: 'translate3d(1.5px,0,0) scale(1.01) rotate(2deg)', offset: 0.66 },
            { transform: 'translate3d(0,0,0) scale(1) rotate(0deg)', offset: 1 },
        ],
        {
            duration: 500,
            easing: 'ease-out',
            fill: 'none',
        }
    );
};

export interface ApplyCloneBaseStylesParams {
    clone: HTMLElement;
    baseSize: number;
    startX: number;
    startY: number;
    startScale: number;
}

export const applyCloneBaseStyles = ({
    clone,
    baseSize,
    startX,
    startY,
    startScale,
}: ApplyCloneBaseStylesParams): void => {
    Object.assign(clone.style, CART_CLONE_BASE_STYLES);

    clone.style.width = `${baseSize}px`;
    clone.style.height = `${baseSize}px`;
    clone.style.transform = `translate3d(${startX}px, ${startY}px, 0) scale(${startScale}) rotate(0deg)`;
};
